import { LegacyPortalDashboardService } from "@spwn-portal/grpc";
/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
/* eslint-enable no-restricted-imports */
import React from "react";
import useSWRMutation from "swr/mutation";

import { useConnectClient } from "../../utility/connectWeb";

const ExportPurchaseDashboardRowsFileKey = "exportPurchaseDashboardRowsFile";

type ExportFileArg = {
  eventIds: string[];
  fromDate?: bigint;
  toDate?: bigint;
};

export const useExportPurchaseDashboardRowsFile = () => {
  const auth = firebase.auth();
  const connectClient = useConnectClient(LegacyPortalDashboardService);
  const currentUserId = auth.currentUser?.uid ?? null;

  const {
    trigger,
    isMutating: isExporting,
    error,
  } = useSWRMutation<
    void,
    Error,
    [string, string | null] | null,
    ExportFileArg
  >(
    currentUserId ? [ExportPurchaseDashboardRowsFileKey, currentUserId] : null,
    async (_, { arg }) => {
      if (!connectClient) {
        throw new Error("Connect client is not initialized");
      }

      const { eventIds, fromDate, toDate } = arg;
      if (eventIds.length === 0) {
        throw new Error("No eventIds found");
      }

      const response = await connectClient.exportPurchaseDashboardRowsFile({
        eventIds,
        fromDate,
        toDate,
      });

      const blob = new Blob([response.file], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = response.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  );

  const exportFile = React.useCallback(
    (eventIds: string[], fromDate?: bigint, toDate?: bigint) => {
      trigger({ eventIds, fromDate, toDate }).catch((err) => {
        console.error("Failed to export purchase dashboard rows file:", err);
      });
    },
    [trigger]
  );

  return { exportFile, isExporting, error };
};
